import React, { Fragment, useState } from "react";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Bg from "../../images/bg/page_bg01.jpg";
import Process from "./Process";
import WorkSection from "../TeamPage/work";
import Header2 from "../../components/Header2/Header2";
import toast from "react-hot-toast";

const CareerPage = (props) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    coverLetter: "",
    resume: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "resume") {
      setFormData({ ...formData, resume: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const SubmitHandler = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("name", formData.name);
    data.append("email", formData.email);
    data.append("phone", formData.phone);
    data.append("address", formData.address);
    data.append("coverLetter", formData.coverLetter);
    data.append("resume", formData.resume);

    try {
      const res = await fetch(
        "http://localhost:5258/api/career/careerCreation",
        {
          method: "POST",
          body: data,
        }
      );

      const result = await res.json();

      if (res.ok) {
        toast.success(result.message || "Form submitted successfully");
        setFormData({
          name: "",
          email: "",
          phone: "",
          address: "",
          coverLetter: "",
          resume: null,
        });
        document.getElementById("file").value = null; // reset file input
      } else {
        toast.error(result.message || "Submission failed");
      }
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    }
  };

  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header2 />
         <section className="page-title cp-page-title pt-50 pos-rel bg_img" style={{ backgroundImage: `url(${Bg})` }}>
                    <div className="container">
                        <div className="page-title-wrap">
                            <div className="row mt-none-30 align-items-center">
                                <div className="col-lg-8 mt-30">
                                    <div className="page-title-box">
                                        {/* <span className="sub-title"><img src={icon} alt="" />Careers</span> */}
                                        <h2 className="title">Be a part of shaping the <br /> future & career opportunities <br /> at SPIOT Systems Private Limited today.</h2>
                                    </div>
                                </div>
                        <div className="col-lg-4 mt-30 flex justify-center">
  <img
    src="https://cdn.prod.website-files.com/67ed2fa2e6078a8a08b4e1fd/68410f045ca39e6b8af7a108_careers-intro-marlabs.png"
    alt="Career"
    className="w-full max-w-[200px] sm:max-w-[300px] lg:max-w-[450px] h-auto"
  />
</div>

                            </div>
                        </div>
                    </div>
                </section>


        <Process />

        {/* 👉 Apply Job Form START */}
        <div className="cp-contact-wrap pt-10 pb-10 bg-light">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12">
                <div className="cs-contact-wrap cs-contact-form cd-contact-form bg-white p-4 p-md-5 rounded-3 shadow-sm">
                  <h2 className="xb-title mb-4 text-center">
                    <i className="fas fa-briefcase me-2 text-primary"></i> Apply
                    for this job
                  </h2>
                  <p className="xb-content text-center text-muted mb-4 mb-md-5">
                    <i className="fas fa-info-circle me-2"></i>
                    SPIOT Systems Private Limited doesn't accept unsolicited resumes from recruiters
                    or employment agencies.
                  </p>

                  <form onSubmit={SubmitHandler} className="contact-form">
                    <div className="row g-3">
                      <div className="col-md-6">
                        <div className="input-field">
                          <label
                            htmlFor="text1"
                            className="form-label fw-bold small"
                          >
                            <i className="fas fa-user me-2 text-primary"></i>
                            Name*
                          </label>
                          <div className="input-box position-relative">
                            <input
                              type="text"
                              name="name"
                              id="text1"
                              className="form-control ps-4"
                              required
                              pattern="[A-Za-z ]+" // ✅ only alphabets + space
                              inputMode="text"
                              value={formData.name}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^[A-Za-z ]*$/.test(value)) {
                                  handleChange(e);
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="input-field">
                          <label
                            htmlFor="text2"
                            className="form-label fw-bold small"
                          >
                            <i className="fas fa-envelope me-2 text-primary"></i>
                            Email*
                          </label>
                          <div className="input-box position-relative">
                            <input
                              type="email"
                              name="email"
                              id="text2"
                              className="form-control ps-4"
                              required
                              value={formData.email}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="input-field">
                          <label
                            htmlFor="text3"
                            className="form-label fw-bold small"
                          >
                            <i className="fas fa-phone me-2 text-primary"></i>
                            Phone*
                          </label>
                          <div className="input-box position-relative">
                            <input
                              type="tel"
                              name="phone"
                              id="text3"
                              className="form-control ps-4"
                              required
                              maxLength={10} // ✅ max length
                              pattern="[0-9]{10}" // ✅ exactly 10 digits
                              inputMode="numeric" // ✅ mobile numeric keypad
                              value={formData.phone}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="input-field">
                          <label
                            htmlFor="text4"
                            className="form-label fw-bold small"
                          >
                            <i className="fas fa-map-marker-alt me-2 text-primary"></i>
                            Address*
                          </label>
                          <div className="input-box position-relative">
                            <input
                              type="text"
                              name="address"
                              id="text4"
                              className="form-control ps-4"
                              required
                              value={formData.address}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="input-field text-field">
                          <label
                            htmlFor="text5"
                            className="form-label fw-bold small"
                          >
                            <i className="fas fa-file-alt me-2 text-primary"></i>
                            Cover Letter
                          </label>
                          <div className="input-box">
                            <textarea
                              name="coverLetter"
                              id="text5"
                              className="form-control"
                              rows="4"
                              placeholder="Tell us why you're the perfect candidate for this position..."
                              value={formData.coverLetter}
                              onChange={handleChange}
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="cp-contact-bottom d-flex flex-column flex-md-row justify-content-between align-items-md-center mt-4 p-3 bg-light rounded">
                      <div className="xb-item--left mb-3 mb-md-0">
                        <label
                          htmlFor="file"
                          className="d-block fw-bold small mb-2"
                        >
                          <i className="fas fa-paperclip me-2 text-primary"></i>
                          Upload your resume / CV*
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            id="file"
                            type="file"
                            name="resume"
                            className="form-control form-control-sm w-[200px]"
                            required
                            onChange={handleChange}
                          />
                        </div>
                        <p className="xb-item--content text-muted small mt-2 mb-0">
                          <i className="fas fa-info-circle me-1"></i>
                          <span>Accepted file types:</span> pdf, doc, jpg. Max.
                          file size: 3 MB.
                        </p>
                      </div>

                      <div className="cp-det-btn">
                        <button className="cp-btn btn btn-primary px-4 py-2 rounded-pill fw-bold">
                          Submit Now <i className="fas fa-arrow-right ms-2"></i>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* 👉 Apply Job Form END */}

        <WorkSection bg={"sbg pt-20"} />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default CareerPage;
